export const locales = {
	label: 'Choix de la langue. Actuellement'
};
